import { render, staticRenderFns } from "./package_detail.vue?vue&type=template&id=57c56fb0&scoped=true&"
import script from "./package_detail.vue?vue&type=script&lang=ts&"
export * from "./package_detail.vue?vue&type=script&lang=ts&"
import style0 from "./package_detail.vue?vue&type=style&index=0&id=57c56fb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c56fb0",
  null
  
)

export default component.exports